// @ts-nocheck
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { Card } from '@mui/material';
import '../components/Style.css';
import Grid from '@material-ui/core/Grid';
// sections

export default function Success() {
  const navigate = useNavigate();
  return (
    <Grid container direction="column" alignItems="center" justify="center" style={{ minHeight: '100vh' }}>
      <Grid item xs={3}>
        <Card sx={{ padding: '70px' }}>
          <div style={{ alignItems: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'center ', marginTop: '10px' }}>
              <p className="title" style={{ fontWeight: 'bold', fontSize: '35px' }}>
                {' '}
                Registration success-full{' '}
              </p>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center ', marginTop: '10px' }}>
              <p className="titleParagraph" style={{ fontSize: '25px' }}>
                {' '}
                You have been successfully onboarded on Stripe.{' '}
              </p>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center ', marginTop: '10px', fontSize: '20px' }}>
              <p className="titleParagraphtwo"> Click here to </p>
              <span
                className="titleParagraphtwo"
                style={{ color: 'blue', cursor: 'pointer' }}
                onClick={() => {
                  navigate('/login');
                }}
              >
                &nbsp;Login
              </span>
            </div>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
}
